module.exports = __webpack_public_path__ + "fonts/prospects.e24034b6.woff";